import Pipeline from './Pipeline'

export default Pipeline
